<template>
	<div class="sf-flex-column h-100">
		<sf-data-table
			ref="mainTable"
			:pageUnit="pagingInfo.pageUnit"
			:totalSize="pagingInfo.totalSize"
			paging
			index
			:columns="mainColumns"
			:rows="mainRows"
			fit="fit"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
			@changedPage="changedPage"
		>
			<template v-slot:customRows="slotProps">
				<template v-if="slotProps.column.property === 'rslrFile'">
					<template v-if="!!slotProps.row.rslrFileId">
						<span @click="() => onDownloadFile(slotProps.row.rslrFileId)" style="cursor: pointer">
							<img src="/img/common/table/icon-sf-excel.svg" alt="excel icon" class="mr-1" />
						</span>
					</template>
				</template>
				<template v-if="slotProps.column.property === 'mark'">
					<template v-if="isMmcAdmin && slotProps.row.calStCd == 'WHSN' && !!slotProps.row.rslrFileId && !!slotProps.row.calRsltCd">
						<!-- 승인 상태일 때 -->
						<i class="icon-sf-circle-bottom successed"></i>
					</template>
					<template v-else>
						<i class="icon-sf-circle-close warned"></i>
					</template>
				</template>
			</template>
			<template v-slot:actionsLeft>
				<!-- 승인 -->
				<sf-button v-if="isButton_(scrId, 'CU') && isMmcAdmin" line icon="round-check-on" :onClick="() => saveAction('cset')">
					{{ getMessage_('QWCC001001') }}
				</sf-button>
			</template>
		</sf-data-table>
		<!-- pop up -->
		<mes-info-popup ref="mesInfoPopup" @Refresh="refresh" :scrId="scrId"></mes-info-popup>
	</div>
</template>

<script>
import _ from 'lodash';
import MesInfoPopup from '@mmc/mmcm/MesInfo/Content/Popup/MesInfoPopup.vue';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mmc/mmcm/MesCalRslt/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { MesInfoPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		clickMesEqipNo(row) {
			this.$refs.mesInfoPopup.open(row);
		},
		async onDownloadFile(fileId) {
			await this.fileDownload_({ fileId, fileSeq: 1 });
		},
		saveAction(param) {
			try {
				const filteredList = _.filter(this.resultList, row => !!row[param]);
				if (!filteredList.length) {
					throw new Error(this.getMessage_('QWCC001556'));
				}
				if (param === 'cset') {
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: this.$sf_formatString(this.getMessage_('QWCC001644'), ['' + filteredList.length]),
						buttons: [{ title: 'Ok', clickFn: () => this.cset(filteredList) }]
					});
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async cset(value) {
			try {
				this.$sf_toggleLoading(true);
				this.setState_({ key: 'csetResultList', value });
				const { code, messageCd } = await this.saveCset_();
				if (code == 0 || code == 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					this.refresh();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		refresh() {
			this.$emit('Refresh');
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh');
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		mainRows() {
			return this.resultList;
		},
		mainColumns() {
			return [
				{
					label: ' ',
					prop: 'mark',
					minWidth: '35px',
					custom: true,
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001001'), //승인 체크박스
					prop: 'cset',
					minWidth: '40px',
					sortable: false,
					form: {
						type: 'checkBox',
						isDisabled: ({ row }) => {
							// 교정상태 : 입고, 교정 성적서 파일 존재, 교정결과 존재일 때
							const result = row.calStCd == 'WHSN' && !!row.rslrFileId && !!row.calRsltCd;
							return !result || !this.isMmcAdmin;
						}
					}
				},
				{
					label: this.getMessage_('QWCC001317'), //관리번호
					prop: 'mesEqipNo',
					minWidth: '100px',
					highlight: true,
					clickEvent: this.clickMesEqipNo
				},
				{
					label: this.getMessage_('QWCC001314'), //장비명
					prop: 'mesEqipNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001321'), //사용부서
					prop: 'useDeptNm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Id',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC000982'), //담당자
					prop: 'user1Nm',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001579'), //교정업체
					prop: 'calInstCd',
					minWidth: '80px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calInstCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001597'), //교정일자
					prop: 'calCmplDd',
					minWidth: '80px'
				},
				{
					label: this.getMessage_('QWCC001345'), //교정결과
					prop: 'calRsltCd',
					minWidth: '80px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calRsltCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFile',
					minWidth: '80px',
					custom: true
				},
				{
					label: this.getMessage_('QWCC001628'), //성적서
					prop: 'rslrFileId',
					minWidth: '1px'
				},
				{
					label: this.getMessage_('QWCC001323'), //교정주기
					prop: 'calCyclCd',
					minWidth: '80px',
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calCyclCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001324'), //차기교정일
					prop: 'nextCalDd',
					minWidth: '100px'
				},
				{
					label: this.getMessage_('QWCC001315'), //가동상태
					prop: 'runStCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.runStCdList,
						isDisabled: () => true // 에디트 방지
					}
				},
				{
					label: this.getMessage_('QWCC001316'), // 교정상태
					prop: 'calStCd',
					minWidth: '80px',
					sortable: true,
					form: {
						type: 'select',
						placeholder: ' - ',
						options: this.calStCdList,
						isDisabled: () => true // 에디트 방지
					}
				}
			];
		}
	}
};
</script>
